import { chakra } from '@enechain/ecloud-designsystem'

/**
 * id 付き native input (`CompactCivilDateField` 内部の `<input type="date">` 等) と
 * label を association する視認上不可視のラベル (a11y)。可視のグループラベルは
 * 別途あっても、 個別項目の accessible name はこちらが担う。
 *
 * 元は `AdminUploadHistory/index.tsx` / `DemandForecastDaily/components/Toolbar.tsx` /
 * `DemandForecastDaily/components/SimpleForecastSettingsDialog.tsx` の 3 箇所で
 * 同一定義が複製されていた (2026-08-12 CompactCivilDateField 移行時に各ページで
 * 個別追加)。 3 箇所で再利用されるため `frontend/apps/ebalance/CLAUDE.md` の
 * 「複数ページで再利用するものだけ共有ディレクトリへ昇格する」基準に従い
 * `components/common/` へ昇格した。
 */
export const HiddenFieldLabel = ({
  htmlFor,
  children,
}: {
  htmlFor: string
  children: React.ReactNode
}): React.ReactElement => (
  <chakra.label
    css={{
      position: 'absolute',
      width: '1px',
      height: '1px',
      overflow: 'hidden',
      clipPath: 'inset(50%)',
      whiteSpace: 'nowrap',
    }}
    htmlFor={htmlFor}
  >
    {children}
  </chakra.label>
)
